type IconName =
  | "car"
  | "home"
  | "heart"
  | "store"
  | "hardhat"
  | "shield"
  | "document"
  | "truck"
  | "boat";

type Props = {
  name: string;
  size?: number;
};

const paths: Record<IconName, JSX.Element> = {
  car: (
    <>
      <path d="M5 17h14" />
      <path d="M7 17l-2-6 3-5h8l3 5-2 6" />
      <circle cx="8" cy="17" r="2" />
      <circle cx="16" cy="17" r="2" />
    </>
  ),
  home: (
    <>
      <path d="M3 11l9-8 9 8" />
      <path d="M5 10v10h14V10" />
      <path d="M10 20v-6h4v6" />
    </>
  ),
  heart: (
    <>
      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
    </>
  ),
  store: (
    <>
      <path d="M3 9l1.5-5h15L21 9" />
      <path d="M4 9v11h16V9" />
      <path d="M3 9a3 3 0 0 0 6 0 3 3 0 0 0 6 0 3 3 0 0 0 6 0" />
      <path d="M9 20v-6h6v6" />
    </>
  ),
  hardhat: (
    <>
      <path d="M2 18h20" />
      <path d="M4 18v-3a8 8 0 0 1 16 0v3" />
      <path d="M10 9V6h4v3" />
    </>
  ),
  shield: (
    <>
      <path d="M12 3l8 3v6c0 5-3.5 8.5-8 9-4.5-.5-8-4-8-9V6l8-3z" />
      <path d="M9 12l2 2 4-4" />
    </>
  ),
  document: (
    <>
      <path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z" />
      <path d="M14 3v6h6" />
      <path d="M8 13h8M8 17h6" />
    </>
  ),
  truck: (
    <>
      <path d="M1 7h13v10H1z" />
      <path d="M14 11h5l3 3v3h-8" />
      <circle cx="6" cy="19" r="2" />
      <circle cx="18" cy="19" r="2" />
    </>
  ),
  boat: (
    <>
      <path d="M3 18c2 1 4 1 6 0s4-1 6 0 4 1 6 0" />
      <path d="M3 14l9-9 9 9" />
      <path d="M5 14V10h14v4" />
      <path d="M12 5v9" />
    </>
  ),
};

const isIconName = (n: string): n is IconName => n in paths;

export function ProductIcon({ name, size = 22 }: Props) {
  const key = isIconName(name) ? name : "shield";
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      {paths[key]}
    </svg>
  );
}
